import { Dispatch } from 'redux';
import * as Autosuggest from 'react-autosuggest';
import patch from './patch';
import debounce from '../../lib/debounce';
import Logger from '../../Logger';
import { getPlacesAutoComplete } from '../../lib/googleMaps';
import CalculatorApi from '../../lib/calculator.api'
import { State, GooglePlace } from '../types';

export type UpdateLocationAutocompleteInput = (value: string, identifier: string) => void;
export const updateLocationAutocompleteInput: UpdateLocationAutocompleteInput = (
  value, identifier
) => (dispatch: Dispatch, _getState: () => State) => {
  dispatch(patch({
    locationAutocomplete: { [identifier]: { inputDisplay: value } }
  }));
};

/**
 * Input location callback for react-autosuggest
 * onSuggestionsFetchRequested. See
 * https://github.com/moroshko/react-autosuggest#onsuggestionsfetchrequested-required.
 */
const modes = [5,4,3,2,1]
export type UpdateLocationSuggestions = (params: Autosuggest.SuggestionsFetchRequestedParams, identifier: string) => void;
export const updateLocationSuggestions: UpdateLocationSuggestions = (
  { value, reason },
  identifier
) => (dispatch: Dispatch, _getState: State) => {
  if (reason === 'input-focused') return;
  dispatch(patch({ locationAutocompleteLoading: true }));
  debounce('updateLocationSuggestions', async () => {
    let locationSuggestions: any[] = [];
    try {
      
      let promises = modes.map((mode)=>
        CalculatorApi.getAutocomplete(value, mode)
      )
      let results = await Promise.all(promises)      
      results.forEach((suggestions, index)=>{
        locationSuggestions.push( ...suggestions.map((suggestion: any)=>(
          { 
            ...suggestion
          })
        ))
      });
      //getPlacesAutoComplete(value);
    } catch (err) {
      Logger.error(err);
      return;
    }
    dispatch(patch({
      locationAutocomplete: { [identifier]: { suggestions: locationSuggestions } },
      locationAutocompleteLoading: false
    }));
  }, 2000);
};

export type OnLocationAutocompleteSelected = (location: GooglePlace, identifier: string) => void;
export const onLocationAutocompleteSelected = (location: GooglePlace, identifier: string) =>
  (dispatch: Dispatch, getState: State) => {
    dispatch(patch({ locationAutocomplete: { [identifier]: { inputDisplay: location.description } } }));
  };
